'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.Platform = Platform;

var _brick = require('./brick');

var _brick2 = _interopRequireDefault(_brick);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function Platform(props) {
	return (0, _brick2.default)(Object.assign({}, props, {
		className: 'rotate45 ' + (props.className || '')
	}));
}

//# sourceMappingURL=platform.jsx.map